import { z } from 'zod';

/** Platform administration: every account and organization, for ``crm_admin`` only. */

export const adminUserSchema = z.object({
  id: z.number().int(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  phone: z.string(),
  role: z.string(),
  isActive: z.boolean(),
  isBlocked: z.boolean(),
  blockedReason: z.string(),
  createdAt: z.string().nullable(),
  lastLoginAt: z.string().nullable(),
});
export type AdminUser = z.infer<typeof adminUserSchema>;

export const blockUserSchema = z.object({
  blocked: z.boolean(),
  reason: z.string().trim().max(500).default(''),
});
export type BlockUser = z.infer<typeof blockUserSchema>;

export const updateUserSchema = z.object({
  firstName: z.string().trim().min(1, 'Введите имя').max(100),
  lastName: z.string().trim().min(1, 'Введите фамилию').max(100),
  phone: z.string().trim().max(32).default(''),
});
export type UpdateUser = z.infer<typeof updateUserSchema>;

export const adminOrganizationSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  inn: z.string(),
  kpp: z.string(),
  ogrn: z.string(),
  email: z.string(),
  phone: z.string(),
  status: z.string(),
  isActive: z.boolean(),
  ownerUserId: z.number().int().nullable(),
  userCount: z.number().int(),
  createdAt: z.string().nullable(),
});
export type AdminOrganization = z.infer<typeof adminOrganizationSchema>;

const digits = (length: number[], label: string) =>
  z
    .string()
    .trim()
    .refine((value) => /^\d+$/.test(value) && length.includes(value.length), {
      message: `${label}: ${length.join(' или ')} цифр`,
    });

const optionalDigits = (length: number[], label: string) =>
  z.union([z.literal(''), digits(length, label)]).default('');

export const createOrganizationSchema = z.object({
  name: z.string().trim().min(1, 'Введите название').max(300),
  inn: digits([10, 12], 'ИНН'),
  kpp: optionalDigits([9], 'КПП'),
  ogrn: optionalDigits([13, 15], 'ОГРН'),
  email: z.union([z.literal(''), z.email('Введите email')]).default(''),
  phone: z.string().trim().max(32).default(''),
  ownerUserId: z.coerce.number().int().positive('Выберите владельца'),
});
export type CreateOrganization = z.infer<typeof createOrganizationSchema>;

export const updateOrganizationSchema = z.object({
  name: z.string().trim().min(1, 'Введите название').max(300),
  kpp: optionalDigits([9], 'КПП'),
  ogrn: optionalDigits([13, 15], 'ОГРН'),
  email: z.union([z.literal(''), z.email('Введите email')]).default(''),
  phone: z.string().trim().max(32).default(''),
  isActive: z.boolean(),
});
export type UpdateOrganization = z.infer<typeof updateOrganizationSchema>;
